import { render } from "./GameCard.vue?vue&type=template&id=0c7e47dc&scoped=true"
import script from "./GameCard.vue?vue&type=script&lang=js"
export * from "./GameCard.vue?vue&type=script&lang=js"

import "./GameCard.vue?vue&type=style&index=0&id=0c7e47dc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/website/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7e47dc"]])

export default __exports__